import { UI_DATE_FORMAT } from 'globalconfig/constants/static';
import moment from 'moment';
import React from 'react';
import * as Yup from 'yup';
import { ErrorIcon, Button, Timezone, Form } from './Form';
import { TermsRenderComponent } from './TermsRenderComponent';

export const TermAndService = ({
  i18n,
  closeModal,
  data,
  saveRegistration,
  callback,
  setOpen,
  open,
  setModalObject,
  setregistrationPopup,
  setregistrationcolorPopup,
  isFlexRegistration,
  captcha
}) => {
  const getTmezonePopup = (type, message, payload) => {
    if (type === 'error') {
      setModalObject({
        header: '',
        content: () => {
          return (
            <div className="successpopup">
              <ErrorIcon />
              <h2> {i18n.t(message)} </h2>
              <div className="deletePopupBtn">
                <Button
                  type="submit"
                  label={i18n.t('common.ok')}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </div>
            </div>
          );
        }
      });
      setOpen(true);
    }
    if (message === 'Timezone not found. Please enter a valid timezone') {
      setregistrationPopup(563);
      setregistrationcolorPopup(true);
      setModalObject({
        header: '',
        content: () => {
          return (
            <Timezone
              closeModal={setOpen}
              payload={payload}
              saveRegistration={saveRegistration}
              callback={(type, message) => {
                if (type === 'success') {
                  window.open('https://gorillasafety.com/shop/', '_blank');
                } else {
                  callback(type, message);
                }
              }}
              registrationcancelPopup={(width) => {
                setregistrationPopup(width);
                setregistrationcolorPopup(false);
              }}
            />
          );
        }
      });
      setOpen(true);
    }
  };
  return (
    <div>
      <Form
        type="server"
        direction="column"
        initialValues={{ agree: '' }}
        RenderComponent={TermsRenderComponent}
        handleOnSubmit={(fields) => {
          const { selectedItem, state, maintenancePeriod, subscriptionTier, ...request } = data;
          delete request['timeZone'];
          delete request['confirm_password'];
          saveRegistration({
            apiId: 'saveRegistration',
            callback: getTmezonePopup,
            data: {
              data: {
                ...request,
                state: state.value,
                maintenancePeriod: parseInt(maintenancePeriod.value, 10),
                maintenanceMileage: parseInt(request.maintenanceMileage, 10),
                initialTrucks: parseInt(request.initialTrucks, 10),
                agree: 'on',
                hireDate: moment(new Date()).format(UI_DATE_FORMAT),
                subscriptionTier: subscriptionTier,
                flexRegistered: isFlexRegistration,
                gRecaptchaResponse: captcha
              }
            }
          });
          closeModal();
        }}
        registrationcancelPopup={(width) => {
          setregistrationPopup(width);
        }}
        customProps={{
          i18n,
          closeModal
        }}
        validationSchema={Yup.object().shape({
          agree: Yup.bool().required(i18n.t('common.fieldRequiredMessage'))
        })}
      />
    </div>
  );
};
